import ConfettiCanvas from 'react-confetti'
import React from 'react'
import debounce from 'lodash/debounce'

export default function Confetti () {
  const confettiWrapperRef = React.useRef(null)
  const [width, setWidth] = React.useState(null)
  const [height, setHeight] = React.useState(null)

  const handleResize = debounce(() => {
    if (confettiWrapperRef && confettiWrapperRef.current) {
      setHeight(confettiWrapperRef.current.offsetHeight)
      setWidth(confettiWrapperRef.current.offsetWidth)
    }
  }, 50)

  React.useEffect(() => {
    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div ref={confettiWrapperRef} className='left-0 top-0 absolute w-full h-full'>
      {(!width || !height) ? null : (
        <ConfettiCanvas
          numberOfPieces={10}
          width={width}
          height={height}
          initialVelocityX={4}
          initialVelocityY={6}
          gravity={0.04}
          opacity={0.9}
          colors={['#ffffff', '#ffffff', '#7799ff', '#39af8c']}
        />
      )}
    </div>
  )
}
